import _regeneratorRuntime from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.to-string.js";
import useSWRV from "swrv";
import moment from "moment";
import { getData } from "@/services/axios";
export default {
  __name: 'LatestGovernmentForum',
  setup: function setup(__props) {
    // @ts-check
    var _useSWRV = useSWRV("forum-latest", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var params, result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = new URLSearchParams({
                limit: String(10)
              });
              _context.next = 3;
              return getData("government_forums?".concat(params.toString()));

            case 3:
              result = _context.sent;
              return _context.abrupt("return", result.items);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), {
      refreshInterval: 600000,
      // 10分ごと更新
      revalidateOnFocus: false
    }),
        forumList = _useSWRV.data;

    return {
      __sfc: true,
      forumList: forumList,
      moment: moment
    };
  }
};